<div *ngIf="checkinMode; else legacyPhoneVerification" class="checkin-phone" [dir]="globalService.isRTL ? 'rtl' : 'ltr'">
  <ng-container *ngIf="sendStatus === 0">
    <label for="checkin-phone-number">{{ text('Mobile number', 'رقم الهاتف') }}</label>
    <div class="checkin-phone-fields" dir="ltr"><select aria-label="Dialing code" [ngModel]="countryCode" (ngModelChange)="changeDialCode($event)" [disabled]="sendingCode || verifyingCode"><option *ngFor="let country of phoneCountries" [value]="country.code">{{ country.name }} ({{ country.dial_code }})</option></select><input id="checkin-phone-number" type="tel" inputmode="tel" autocomplete="tel-national" [(ngModel)]="phone_number" (input)="phoneNumberChange($event)" (keydown.enter)="$event.preventDefault(); SendCode()" [readonly]="sendingCode" /></div>
    <app-user-message *ngIf="errorMessage" type="error" [message]="errorMessage" [dismissible]="false"></app-user-message>
    <button type="button" class="btn btn-primary btn-block" (click)="SendCode()" [disabled]="sendingCode" [attr.aria-busy]="sendingCode">{{ sendingCode ? text('Sending code…', 'جارٍ إرسال الرمز…') : text('Send verification code', 'إرسال رمز التأكيد') }}</button>
  </ng-container>
  <ng-container *ngIf="sendStatus === 1">
    <h3>{{ text('Enter your code', 'أدخل رمز التأكيد') }}</h3><p>{{ text('We sent a four-digit code to', 'تم إرسال رمز من أربعة أرقام إلى') }} <strong dir="ltr">{{ maskedNumber }}</strong>.</p>
    <button type="button" class="checkin-phone-link" (click)="Clear()" [disabled]="sendingCode || verifyingCode">{{ text('Change number', 'تغيير الرقم') }}</button>
    <label for="checkin-verification-code">{{ text('Verification code', 'رمز التأكيد') }}</label><input id="checkin-verification-code" class="checkin-phone-code" type="text" inputmode="numeric" autocomplete="one-time-code" maxlength="4" [(ngModel)]="verificationCode" (input)="errorMessage = ''" (keydown.enter)="$event.preventDefault(); VerifyCode()" [readonly]="verifyingCode || sendingCode" dir="ltr" />
    <app-user-message *ngIf="errorMessage" type="error" [message]="errorMessage" [dismissible]="false"></app-user-message><p *ngIf="sentAgain && !errorMessage" role="status">{{ text('A new code has been sent.', 'تم إرسال رمز جديد.') }}</p>
    <button type="button" class="btn btn-primary btn-block" (click)="VerifyCode()" [disabled]="verifyingCode || sendingCode" [attr.aria-busy]="verifyingCode">{{ verifyingCode ? text('Verifying…', 'جارٍ التأكيد…') : text('Verify & continue', 'تأكيد ومتابعة') }}</button>
    <button type="button" class="checkin-phone-link" (click)="SendCode()" [disabled]="resendSeconds > 0 || sendingCode || verifyingCode">{{ resendSeconds > 0 ? text('Resend code in ', 'إعادة الإرسال خلال ') + resendSeconds + text(' s', ' ثانية') : text('Resend code', 'إعادة إرسال الرمز') }}</button>
  </ng-container>
</div>
<ng-template #legacyPhoneVerification><div class="form-group ">
    <div class="row">
        <div [ngClass]="portrait == true? 'col-12': 'col-6'" *ngIf="sendStatus != 3">
            <label for="phone_number">{{
                globalService.Get("CELLPHONE")
                }} <span class="required-marker" aria-label="required">*</span></label>
            <div class="input-group" dir="ltr">
                <div class="input-group-prepend">
                    <div class="input-group-text">{{ dial_code }}</div>
                </div>
                <input type="text" OnlyNumber="true" [readonly]="sendStatus > 0 || sendingCode || verifyingCode" [disabled]="enabled == false" id="phone_number"
                    [(ngModel)]="phone_number" (input)="phoneNumberChange($event)" class="form-control" [class.unconfirmedPhone]="phoneConfirmed == false"
                    autocomplete="off" />
            </div>
        </div>
        <div [ngClass]="portrait == true? 'col-12': 'col-6'"
            *ngIf="sendStatus == 0 && phone_number != null && phone_number.length > 9" class="mt-4">
            <div *ngIf="errorMessage == ''">
                <label class="mr-sm-3 mr-1">{{
                    globalService.Get("VERIFY_PHONE")

                    }}</label>
                <button type="button" class="btn btn-small btn-secondary" (click)="SendCode()" [disabled]="sendingCode || verifyingCode" [attr.aria-busy]="sendingCode"><i *ngIf="sendingCode" class="fas fa-spinner fa-spin mr-1" aria-hidden="true"></i>{{ globalService.Get('SEND_CODE') }}</button>
            </div>
            <div *ngIf="errorMessage != ''">
                <app-prompt-message [showForm]="errorMessage != ''" color="primary" (onClose)="Retry()"
                    [message]="errorMessage">
                </app-prompt-message>
                <div class="row">
                    <div class="col-6">
                        <input type="button" class="btn btn-small btn-block btn-primary" (click)="Retry()" value="Try Again"
                            >
                    </div>
                    <div class="col-6">
                        <input type="button" class="btn btn-small btn-block btn-success"  (click)="Signup()"
                            value="Create Account">
                    </div>
                </div>
            </div>
        </div>
        <div [ngClass]="portrait == true? 'col-12': 'col-6'" *ngIf="sendStatus == 1">
            <p *ngIf="errorMessage" class="text-danger" role="alert">{{ errorMessage }}</p>
            <label class="mt-3 mr-sm-3 mr-1">{{
                globalService.Get("ENTER_4DIGIT")
                }}</label>
            <div class="row">
                <div class="col-6">
                    <input type="text" OnlyNumber="true" id="verificationCode" maxlength="4"
                        [(ngModel)]="verificationCode" class="form-control" autocomplete="off">
                </div>
                <div class="col-6">
                    <button type="button" class="btn btn-small btn-secondary" (click)="VerifyCode()" [disabled]="verifyingCode || sendingCode" [attr.aria-busy]="verifyingCode"><i *ngIf="verifyingCode" class="fas fa-spinner fa-spin mr-1" aria-hidden="true"></i>{{ globalService.Get('VERIFY') }}</button>
                </div>
            </div>
        </div>
        <div [ngClass]="portrait == true? 'col-12': 'col-6'" *ngIf="sendStatus == 2">
            <label class="mr-sm-3 mr-1">{{
                globalService.Get("CLICK_TO_CHANGE")
                }}</label>

            <div>
                <input type="button" class="btn btn-small btn-secondary" (click)="Clear()"
                    [value]="globalService.Get('CLEAR')">
            </div>
        </div>
        <div [ngClass]="portrait == true? 'col-12': 'col-6'" *ngIf="sendStatus == 3">
            <span>Failed To Verify</span>
        </div>
    </div>
</div></ng-template>
